import React, { useState } from "react";

import { Box, Button, CircularProgress } from "@mui/material";

import { InputField, PopUpMsg, SelectBox } from "../../../components";
import API from "../../../axios";

export default function TranslationForm({ handleSubmission = () => { } }) {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    key: "",
    english: "",
    german: "",
    other: "",
    role: "general",
  });

  const [payload, setPayload] = useState({
    type: "success",
    message: "",
  });
  const [open, setOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const reset = () => {
    setFormData({
      key: "",
      english: "",
      german: "",
      other: "",
      role: "general",
    });
  };

  const handleForm = async (e) => {
    e.preventDefault();
    let data = formData;
    for (const key in data) {
      if (data[key] === "") {
        delete data[key];
      }
    }
    setIsLoading(true);
    try {
      await API("admin/translation", "post", data);
      setPayload({
        type: "success",
        message: "Key has been added successfully!",
      });
      reset();
    } catch (err) {
      setPayload({
        type: "error",
        message: "Error Occurred. Please try again!",
      });
    } finally {
      setIsLoading(false);
      setOpen(true);

    }
  };

  return (
    <>
      <form autoComplete="off" onSubmit={handleForm}>
        <Box mt={2} mb={3}>
          <InputField
            placeholder="Type..."
            size="small"
            label="Key"
            name="key"
            initValue={formData.key}
            required
            fullWidth
            styles={{ mb: 2 }}
            handleChange={handleChange}
          />
          <InputField
            placeholder="Type..."
            size="small"
            label="English (en)"
            name="english"
            multiline
            initValue={formData.english}
            required
            fullWidth
            styles={{ mb: 2 }}
            handleChange={handleChange}
          />
          <InputField
            placeholder="Type..."
            size="small"
            label="German (de)"
            name="german"
            initValue={formData.german}
            required
            fullWidth
            multiline
            styles={{ mb: 2 }}
            handleChange={handleChange}
          />
          <InputField
            placeholder="Type..."
            size="small"
            label="Other lang"
            name="other"
            initValue={formData.other}
            fullWidth
            multiline
            styles={{ mb: 2 }}
            handleChange={handleChange}
          />
          <SelectBox
            size="small"
            label="Role"
            name="role"
            handleChange={handleChange}
            initValue={formData.role}
            required
            items={[
              { label: "General", value: "general" },
              { label: "Super Admin", value: "superadmin" },
              { label: "Manager", value: "manager" },
              { label: "Employee", value: "employee" },
            ]}
          />
          <Box sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              onClick={() => { }}
              sx={{
                mt: 2,
              }}
              disabled={isLoading}
              type="submit"
            >
              {isLoading ? (
                <CircularProgress
                  size={18}
                  sx={{ color: "#fff", mr: 1, size: "12px" }}
                />
              ) : null}
              Add
            </Button>
          </Box>
        </Box>
      </form>
      <PopUpMsg
        open={!!open}
        type={payload.type}
        message={payload.message}
        handleClose={() => setOpen(false)}
      />
    </>
  );
}
